import { render, staticRenderFns } from "./BatchLockTimeForm.vue?vue&type=template&id=b4dd81bc&scoped=true"
import script from "./BatchLockTimeForm.vue?vue&type=script&lang=js"
export * from "./BatchLockTimeForm.vue?vue&type=script&lang=js"
import style0 from "./BatchLockTimeForm.vue?vue&type=style&index=0&id=b4dd81bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4dd81bc",
  null
  
)

export default component.exports